import { apiSlice } from "../../api/apiSlice";

export const bmciEventApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getParticipants: builder.query({
      query: ({ search = "", page = 1, limit = 30 } = {}) =>
        `/bmci-event?search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`,
    }),
    distributeParticipant: builder.mutation({
      query: (id) => ({
        url: `/bmci-event/${id}/distribute`,
        method: "PATCH",
      }),
    }),
    getOrders: builder.query({
      query: () => "/bmci-event/orders",
      providesTags: ["bmciOrder"],
    }),
    createOrder: builder.mutation({
      query: (body) => ({
        url: "/bmci-event/orders",
        method: "POST",
        body,
      }),
      invalidatesTags: ["bmciOrder"],
    }),
  }),
});

export const {
  useGetParticipantsQuery,
  useDistributeParticipantMutation,
  useGetOrdersQuery,
  useCreateOrderMutation,
} = bmciEventApiSlice;
